export const hdmgdjGenres = [
  {
    id: "g-city",
    name: "都市逆袭",
    count: "1,286 部",
    image: "/images/genre-city.jpg",
  },
  {
    id: "g-ancient",
    name: "古装穿越",
    count: "962 部",
    image: "/images/genre-ancient.jpg",
  },
  {
    id: "g-mystery",
    name: "悬疑烧脑",
    count: "738 部",
    image: "/images/genre-mystery.jpg",
  },
  {
    id: "g-comedy",
    name: "沙雕搞笑",
    count: "1,024 部",
    image: "/images/genre-comedy.jpg",
  },
  {
    id: "g-romance",
    name: "甜宠恋爱",
    count: "1,140 部",
    image: "/images/genre-romance.jpg",
  },
  {
    id: "g-fantasy",
    name: "玄幻修仙",
    count: "856 部",
    image: "/images/genre-fantasy.jpg",
  },
];